import { useEffect, useState } from "react"
import useWindowDimensions from "@hooks/useWindowDimensions"
import useMountObserver from "@hooks/useMountObserver" 
import SearchForBlogSections from "@utils/searchForBlogSections"
import { useTableOfContent } from ".."

const useArticlePage = ({ postsList, post }) => {
  // const { isMounted } = useMountObserver();
  const [isMounted, setIsMounted] = useState(false)
  const { isDesktop, isTablet, isMobile } = useWindowDimensions()
  const [otherArticles, setOtherArticles] = useState([])
  const [articleTopics, setArticleTopics] = useState([])
  const [selectedItem, setSelectedItem] = useState("")
  const { content } = useTableOfContent(SearchForBlogSections.searchForYoutubeSections(post.content));

  useEffect(() => {
    const parsedTopics = [
      ...new DOMParser()
        .parseFromString(post.content, "text/html")
        .querySelectorAll("h2"),
    ].map(({ innerText }) => ({
      innerText,
    }))

    const shuffled = [...postsList].sort(() => 0.5 - Math.random())
    setTimeout(() => setArticleTopics(parsedTopics))
    setOtherArticles(shuffled.slice(0, 3))
    setTimeout(() => {
      setIsMounted(true)
    }, 100)
  }, [])
  
  useEffect(() => {
    selectedItem &&
      document.querySelectorAll(`[id=${selectedItem}]`)[1].scrollIntoView({
        behavior: "smooth",
      })
  }, [selectedItem])

  return {
    isMounted,
    isDesktop,
    isTablet,
    isMobile,
    otherArticles,
    articleTopics,
    content,
    setSelectedItem,
  }
}

export default useArticlePage
